define('shared/initializer/form/constants',[],function  () {
    'use strict';

    // Please stick with UPPER_CASED_NAMING convention for constants
    // https://google.github.io/styleguide/javascriptguide.xml

    return {
        FIELD: {
            LEAD: {
                FIRSTNAME:'first_name',
                LASTNAME: 'last_name',
                LOCAL: 'local',
                HAS_OFFERS_TRANSATION_ID: 'hoTransactionId',
                GOOGLE_CLICK_ID: 'gclid',
                MARIN_CLICK_ID: 'ruboid',
                UTM_SOURCE: 'utm_source',
                UTM_MEDIUM: 'utm_medium',
                UTM_CAMPAIGN: 'utm_campaign',
                UTM_TERM: 'utm_term',
                UTM_CONTENT: 'utm_content',
                UTM_ADGROUP: 'adgroup',
                GA_CLIENT_ID: 'GAClientId',
                ADOBE_VISITOR_ID: 'AdobeVisitorId',
                POSTCODE: 'Postcode',
                REFERRED_BY: 'ReferredBy',
                REFERRED_FROM: 'ReferredFrom',
                AGE_GROUP: 'age',
                CALL_TIME: 'calltime'
            },
            CREDIT_CARD_MARKET_CODE: 'CCMarketCode',
            CREDIT_CARD_FULLNAME: 'CreditCardName',
            CREDIT_CARD_LASTNAME: 'CCLastName',
            CREDIT_CARD_FIRSTNAME: 'CCFirstName',
            CREDIT_CARD_TYPE: 'CCType',
            CREDIT_CARD_NUMBER: 'CreditCardNumber',
            EMAIL_ENGLISH: 'SubscribeToEmailEnglish',
            smsnotification: 'smsnotification',
            EmailEnglish: 'emailenglish',
            EnglishEmail: 'englishemail',
            MemberSubscribeToEmailEnglish: 'member.SubscribeToEmailEnglish',
            MemberSubscribeToPartnerPromo: 'member.SubscribeToPartnerPromo',
            MemberSubscribeToDailyLesson: 'member.SubscribeToDailyLesson',
            MemberSubscribeToETPromo: 'member.SubscribeToETPromo',
            MemberSubscribeToSMS: 'member.SubscribeToSMS',
            CouponCode: 'CouponCode',
            OFFER_ID: 'offerid',
            PARTNER: 'partnerCode',
            MemberPartner: 'member.PartnerCode',
            LANGUAGE: ['languageCode', 'cultureCode'],
            COUNTRY: ['countryCode', 'marketCode'],
            MEMBER_ID: 'memberid',
            OMNITURE_NAME: ['OmnitureFriendlyName','omniturefriendlyname2'],
            ETAG: 'etag',
            MemberEtag: 'member.Etag',
            CMUS: 'cmus',
            PURCHASEINFO_ETAG: 'purchaseInfo.Etag',
            PURCHASEINFO_MARKETCODE: 'purchaseInfo.MarketCode',
            PURCHASEINFO_MEMBERID: 'purchaseInfo.MemberId',
            PURCHASEINFO_COUPONCODE: 'purchaseInfo.CouponCode',
            PURCHASEINFO_OFFERID: 'purchaseInfo.OfferId',
            PURCHASEINFO_PARTNERCODE: 'purchaseInfo.PartnerCode',
            CONFIRM_PASSWORD: 'confirmpassword',
            EFID: 'EFID',
            MemberEFID: 'member.EFID',
            HasOffersTransactionId: 'HasOffersTransactionId',
            MemberHasOffersTransactionId: 'member.HasOffersTransactionId',
            GoogleClickId: 'GoogleClickId',
            MemberGoogleClickId: 'member.GoogleClickId',
            MarinClickId: 'MarinClickId',
            MemberMarinClickId: 'member.MarinClickId',
            PayPalCancelUrl: 'flowInfo.CancelUrl',
            PayPalReturnUrl: 'flowInfo.ReturnUrl',
            LOCATION_COUNTRY: 'location-country',
            LOCATION_STATE: 'location-state',
            STATE: 'state',
            StateCode: 'StateCode',
            MemberStateCode: 'member.StateCode',
            LOCATION_CITY: 'location-city',
            CITY: 'city',
            CITY_OTHER: 'cityother',
            CityCode: 'CityCode',
            MemberCityCode: 'member.CityCode',
            PHONE: 'telephone',
            PHONE_TYPE: 'telephone-type',
            HomePhone: 'HomePhone',
            MobilePhone: 'MobilePhone',
            MemberHomePhone: 'member.HomePhone',
            MemberMobilePhone: 'member.MobilePhone',
            MemeberMemberId: 'member.Member_id',
            payPalPaymentInfoToken: 'payPalPaymentInfo.Token',
            payPalPaymentInfoPayerID: 'payPalPaymentInfo.PayerID',
            dcInfoAccountName: 'dcInfo.AccountName',
            dcInfoMandateId: 'dcInfo.MandateId',
            dcInfoMandateDate: 'dcInfo.MandateDate',
            PASSWORD: 'password',
            MemberPassword: 'member.Password',
            SHOW_PASSWORD: 'showpassword',
            redemptionCode: 'redemptionCode',
            TOC: 'toc',
            FirstName: 'firstname',
            MemberFirstName: 'member.FirstName',
            LastName: 'lastname',
            MemberLastName: 'member.LastName',
            Email: 'email',
            MemberEmail: 'member.Email',
            MemberLanguageCode: 'member.LanguageCode',
            MemberCountryCode: 'member.CountryCode',
            MemberOmnitureFriendlyName: 'member.OmnitureFriendlyName',
            OnSuccessUrl: 'OnSuccessUrl',
            MemberOnSuccessUrl: 'member.OnSuccessUrl',
            TradeDoublerUId: 'TradeDoublerUId',
            MemberTradeDoublerUId: 'member.TradeDoublerUId',
            Age: 'Age',
            MemberAge: 'member.Age',
            MemberUtmSource: 'member.UtmSource',
            MemberUtmMedium: 'member.UtmMedium',
            MemberUtmCampaign: 'member.UtmCampaign',
            MemberUtmTerm: 'member.UtmTerm',
            MemberUtmContent: 'member.UtmContent',
            MemberAdGroup: 'member.AdGroup',
            GAClientId: 'GAClientId',
            MemberGAClientId: 'member.GAClientId',
            AdobeVisitorId: 'AdobeVisitorId',
            MemberAdobeVisitorId: 'member.AdobeVisitorId',
            ReferredBy: 'ReferredBy',
            MemberReferredBy: 'member.ReferredBy',
            ReferredFrom: 'ReferredFrom',
            MemberReferredFrom: 'member.ReferredFrom',
            DebitCardBankCode: 'dcInfo.BankCode',
            DebitCardAccountNumber: 'dcInfo.AccountNumber',
            MY_PASSWORD: 'mypassword',
            NEW_PASSWORD: 'newPassword',
            DynamicSubscribe: 'dynamicsubscribe',
            EmailList: 'emaillist',
            LeadId: 'leadid',
            AcademicQualifications: 'educationlevel',
            StudyFrequency: 'studyhoursperweek'
        },
        State: {
            TrackingEvents: 'tracking.events',
            TrackingPendingEvents: 'pending.events',
            RedemptionCode: 'order.redemptionCode',
            PageEtag: 'page.etag',
            PageLanguage: 'page.language',
            PageMarket: 'page.market',
            PageName: 'page.name',
            SessionEtag: 'session.etag',
            SessionPartnerCode: 'session.partner_code',
            UserMemberId: 'user.member_id',
            UserMemberType: 'user.member_type',
            TrackingCheckoutFlowType: 'tracking.checkout_flow_type',
            OrderOfferId: 'order.offer_id',
            TrackingCheckoutFlowTypeCustom: 'session.checkout_flow_type_custom',
            NoCard: 'persistent.debugger_nocard_payment'
        },
        EVENT: {
            MemberRegistration: 'MemberRegistration',
            ORDER_CREATION: 'OrderCreation',
            LeadOnlineEnquiry: 'LeadOnlineEnquiry',
            EmailEnglish: 'EmailEnglish'
        },
        CREDITCARDTYPE: {
            Visa: 'Visa',
            Amex: 'Amex',
            JCB: 'JCB',
            MasterCard: 'MasterCard'
        },
        CheckoutFlowType:{
            Default: 'default',
            Return: 'return',
            Upsell: 'upsell',
            Redemption: 'redemption',
            WelcomeBack: 'welcome-back',
            PaymentUpdate: 'payment-update'
        },
        CheckoutDefaultFlowName:{
            Default: 'default',
            Return: 'return',
            Upsell: 'upsell'
        },
        StudentType:{
            CurrentStudent: 'CurrentStudent',
            LapsedStudent: 'LapsedStudent',
            NeverStudent: 'NeverStudent'
        },
        OfferType:{
            All: 'All',
            Unknown: 'Unknown',
            Upsell: 'Upsell',
            Subscription: 'Subscription',
            Free: 'Free',
            SME: 'SME'
        },
        PaymentType:{
            CreditCard: 'CreditCard',
            DirectDebit: 'DirectDebit',
            Redemption: 'Redemption',
            Offline: 'Offline',
            NationalCard: 'NationalCard',
            PayPal: 'PayPal'
        },
        PayPalFlow:{
            ReturnFromPayPal: 'ReturnFromPayPal',
            CancelFromPayPal: 'CancelFromPayPal'
        },
        FormType:{
            CreditCard: 'creditcard',
            DirectDebit: 'directdebit',
            PayPal: 'paypal'
        },
        PhoneType:{
            Mobile: 'mobile',
            Landline: 'landline'
        },
        QueryString:{
            updateMemberInfo: 'updatememberinfo'
        },
        // CookieKey:{
        // Please use module `shared/my/cmus` instead
        //     CMUS: 'CMus'
        // },
        ServiceUrl:{
            UpdateMember: '/services/commerce-v4/membermanager/update'
        },
        SUBMISSION: {
            HUB_LOAD_FINISHED: '/form/load/finished'
        }
    };
});

